import { Component, Inject, Injectable } from '@angular/core';
import { SavedState, UnsavedDataHandler, UNSAVED_DATA_HANDLER_TOKEN } from '@galaxy/email-ui/domain-authorization';
import { SenderType } from '@vendasta/email';
import { Observable } from 'rxjs';
import { PARTNER_ID_INJECTION_TOKEN } from '../core/constants';
import { ComponentCanDeactivate } from '../core/guards/pending-changes-guard.service';

@Injectable()
class UnsavedChanges implements UnsavedDataHandler {
  private hasUnsavedChanges = false;

  canDeactivate(): boolean {
    return !this.hasUnsavedChanges;
  }

  notifyStateChanged(newState: SavedState): void {
    switch (newState) {
      case SavedState.SAFE_TO_NAVIGATE_AWAY:
        this.hasUnsavedChanges = false;
        return;
      case SavedState.HAS_UNSAVED_CHANGES:
        this.hasUnsavedChanges = true;
        return;
      default:
        throw new Error(`Unexpected SavedState: ${newState}`);
    }
  }
}

@Component({
  templateUrl: './email-settings.component.html',
  styleUrls: ['./email-settings.component.scss'],
  providers: [UnsavedChanges, { provide: UNSAVED_DATA_HANDLER_TOKEN, useExisting: UnsavedChanges }],
  standalone: false,
})
export class EmailSettingsComponent extends ComponentCanDeactivate {
  readonly SenderTypePartner = SenderType.SENDER_TYPE_PARTNER;

  constructor(
    @Inject(PARTNER_ID_INJECTION_TOKEN) readonly partnerId$: Observable<string>,
    private readonly unsavedChanges: UnsavedChanges,
  ) {
    super();
  }

  canDeactivate(): boolean | Observable<boolean> {
    return this.unsavedChanges.canDeactivate();
  }
}
